/**
 * 計測同意（オプトアウト方式）の保存値を扱う共通モジュール
 *
 * バナー（AnalyticsProvider）が保存値の書き込みと画面制御を担い、
 * 各計測ヘルパー（gtag / gtm / twq）は送信直前に isTrackingRejected() で
 * 拒否済みかを確認する。スクリプトの読み込み制御だけでは、拒否した瞬間の
 * ページで既に読み込まれた GTM / X Pixel へ自前イベントが流れ続けるため、
 * 送信側にもゲートを置く（プライバシーポリシー第10条の「拒否を選択した場合、
 * 当社は以後これらのCookieを使用しない」を実装で担保する多層防御）。
 */

export const CONSENT_KEY = "cookie-consent";

export type ConsentState = "accepted" | "rejected" | null;

export function readConsent(): ConsentState {
  if (typeof window === "undefined") return null;
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    if (value === "accepted" || value === "rejected") return value;
    return null;
  } catch {
    return null;
  }
}

export function writeConsent(value: "accepted" | "rejected"): void {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // localStorage unavailable (private browsing etc.)
  }
}

/**
 * 拒否済みかどうか。計測ヘルパーの送信ゲートに使う。
 * 毎回 localStorage を読むことで、バナー操作直後や別タブでの拒否も
 * モジュール状態の同期なしに反映される（イベント送信は低頻度なので性能影響はない）
 */
export function isTrackingRejected(): boolean {
  return readConsent() === "rejected";
}
